module.exports = __webpack_public_path__ + "static/media/Yvette L.69a0adbc.png";